export default {
  name: "LockSolid",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M25.99 12H23.5V9c0-3.48-2.32-7-7.5-7S8.5 5.52 8.5 9v3H6.01C4.9 12 4 12.9 4 14.01v13.98C4 29.1 4.9 30 6.01 30h19.98c1.11 0 2.01-.9 2.01-2.01V14.01c0-1.11-.9-2.01-2.01-2.01zM17.5 22.6V24a1.5 1.5 0 1 1-3 0v-1.4c-.9-.5-1.5-1.46-1.5-2.6 0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.14-.6 2.1-1.5 2.6zm3-10.6h-9V9c0-1.2.44-4 4.5-4s4.5 2.8 4.5 4v3z",
  },
}
